import {
  FEEDBACK_ACTIONS_OVERLAY,
  FEEDBACK_OVERLAY
} from "shared/context/overlay/types"
import { useAuth } from "shared/lib/useAuth"
import { useEvent } from "shared/lib/useEvent"
import { useIsProductConfigurationPage } from "shared/lib/useIsProductConfigurationPage"
import { useOverlay } from "shared/lib/useOverlay"
import { useScreenSize } from "shared/lib/useScreenSize"
import { FeedbackType } from "shared/types/FeedbackType"

import { useFeedback } from "features/feedback/model/useFeedback"

import { FeedbackButtonModel } from "../FeedbackButton"

export function useFeedbackButtonModel(): FeedbackButtonModel {
  const { isTablet } = useScreenSize()
  const { isAuthenticated } = useAuth()

  const {
    openOverlay: openFeedbackActions,
    isOpen: isFeedbackActionsOverlayOpen
  } = useOverlay(FEEDBACK_ACTIONS_OVERLAY)

  const { isOpen: isFeedbackOverlayOpen } = useOverlay(FEEDBACK_OVERLAY)

  const showFeedbackActions = useEvent(() => {
    openFeedbackActions(null)
  })

  const { openFeedbackOverlay } = useFeedback()

  const handleOpenFeedbackOverlayByType = useEvent(
    (feedbackType: FeedbackType) => {
      openFeedbackOverlay({ feedbackType })
    }
  )

  const isProductConfigurationPage = useIsProductConfigurationPage()

  const isHidden =
    !isAuthenticated ||
    isProductConfigurationPage ||
    isFeedbackActionsOverlayOpen ||
    isFeedbackOverlayOpen

  return {
    isHidden,
    hidePopup: isTablet,
    onClick: isTablet ? showFeedbackActions : undefined,
    onFeedbackTypeSelect: handleOpenFeedbackOverlayByType
  }
}
